import { Box } from '@mui/material';
import { SystemErrorPanel } from '@/components/SystemErrorPanel';

export const ContactPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <SystemErrorPanel />
    </Box>
  );
};
